/** @format */

import React, { useMemo, memo } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

interface DownlineItem {
  name: string;
  officeId: string;
}

interface OfficeDropdownProps {
  value?: string;
  onChange?: (officeId: string) => void;
}

/**
 * Office Dropdown Component
 * Uses user's officeDownLines from Redux for selection in table editing
 */
const OfficeDropdown: React.FC<OfficeDropdownProps> = ({ value, onChange }) => {
  // Get user data from Redux
  const userData = useSelector((state: RootState) => (state.user as any).userData);

  // Get offices from user details
  const offices: DownlineItem[] = userData?.officeDownLines?.downlines || [];

  const options = useMemo(() => {
    if (!offices || offices.length === 0) return [];
    return offices.map((office: DownlineItem) => ({
      label: office.name,
      value: office.officeId,
    }));
  }, [offices]);

  return (
    <Select
      placeholder='Select Office'
      value={value || undefined}
      onChange={onChange}
      options={options}
      style={{ width: '100%' }}
      showSearch
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default memo(OfficeDropdown);
